export default __webpack_public_path__ + "static/media/BSC.c1198f62.svg";